import React, { FC } from "react"

import { generateConditionalClassName } from "@utils"

import "./ToggleWithText.scss"

export enum TOGGLE_COLORS {
  CLAY = "CLAY",
  ORANGE = "ORANGE",
}

export enum TOGGLE_SIZES {
  S = "S",
  M = "M",
  DYNAMIC = "DYNAMIC",
}

export type ToggleWithTextProps = {
  color?: TOGGLE_COLORS,
  options: {
    title: string,
    onClick: () => void,
    isActive?: boolean,
  }[]
  size: TOGGLE_SIZES
}

const ToggleWithText: FC<ToggleWithTextProps> = ({
  color = TOGGLE_COLORS.CLAY,
  options,
  size = TOGGLE_SIZES.M,
}) => {
  return (
    <div
      className={generateConditionalClassName({
        ToggleWithText: true,
        [`color--${color.toLowerCase()}`]: !!color,
        [`size--${size}`]: true,
      })}
    >
      {
        options.map(option => (
          <button
            key={option.title}
            className={generateConditionalClassName({
              "is-active": !!option.isActive,
            })}
            onClick={option.onClick}
          >
            <span>{option.title}</span>
          </button>
        ))
      }
    </div >
  )
}

export default ToggleWithText
